import React, { useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import Login from '../../components/global/login'
import { matchPassword, restrictInValidCharPassword, validateEmail, validatePassword, restrictSpecialChar, restrictInputValues, isPermissionExist, sortPortalPermissionByKey, restrictLeadingTrailingSpace, handleKeyPressRestrictLeadingTrailingSpace, requiredTextInput } from '../../utils/helper'
const phoneMaskGenerator = createDefaultMaskGenerator('(999) 999-9999')
import { getVehicleModelList } from '../../redux/actions/VehicleListAction'
import { Circles } from 'react-loader-spinner'



function SignUp(props) {

    const { setPage, isLoggedIn, dispatch, formData, setFormData, formError, partnerDetails,
        setInvalidCredentialsError, validator } = props
    const [isLoginModal, setLoginModal] = useState(false)
    // const [zipcode, setZipcode] = useState()
    // const [zipcode] = useState()
    const [caller, setCaller] = useState()
    // show and hide passowrd 
    const [cpasswordShown, setCPasswordShown] = useState(false)
    const [mpasswordShown, setMPasswordShown] = useState(false)
    const [vehicleDetailsList, setVehicleDetailsList] = useState(EMPTY_ARRAY)

    // for disbaled functionallty 
    const [loginData, setLoginData] = useState(EMPTY_OBJECT)
    const [accessPermissions, setAccessPermissions] = useState('')

    // const validateEmails = (email) => {
    //     // Define the regular expression for the special domain
    //     const specialDomainRegex = /^[a-zA-Z0-9._%+-]+@maine\.edu$/
    //     return specialDomainRegex.test(email)
    //   }
    const inputRef = useRef(null)
    useEffect(() => {
        inputRef.current.focus()
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
        setAccessPermissions(getAccessPermissionData)
    }, [EMPTY_ARRAY, partnerDetails])

    const handleInputFieldsData = (e) => {
        const { name, value } = e.target

        if (name === 'zipcode') {
            // let str = value
            // let pattern = /\d/
            // str.match(pattern) ? setZipcode('') : setZipcode('The zipcode contain at least a number.')
            setFormData({ ...formData, 'zipcode': value })
        }

        if (name === 'country') {
            getStateByCountry(value)

        }

        if (name === 'email') {
            setInvalidCredentialsError('')
        }

        // if(name == 'state'){
        //     const selectedState = vehicleDetailsList?.state?.filter((item) => item?.state_code == value)
        //     setFormData({ ...formData, ['state']: selectedState?.[0]?.id })
        // }else{
        //     setFormData({ ...formData, [name]: value })
        // }

        setFormData({ ...formData, [name]: restrictLeadingTrailingSpace(value) })


    }

    const handlePhoneChange = (value) => {
        setFormData({ ...formData, ['phone']: value })
    }

    const getStateByCountry = (value) => {
        // ({ ...formData, ['city']: ''})
        let countyLists = vehicleDetailsList?.country ? vehicleDetailsList?.country : formData?.allModel?.country
        let countryData = countyLists?.filter((v) => v?.country_code == value || v?.name == value)
        dispatch(getVehicleModelList(partnerDetails?.facilities?.[0]?.country_code, countryData?.[0]?.id)).then((res) => {
            setVehicleDetailsList(res)
            setFormData({ ...formData, 'country': countryData?.[0]?.country_code })
        })

    }

    const getVehical = () => {
        setFormData({ ...formData, ['city']: formData?.selFaclity?.geolocations?.city })

        // as discuss with santosh sir we call state list on behalf of first added vehicle country
        let firstVehicleCountry = formData?.vehicleList?.[0]?.country ? formData?.vehicleList?.[0]?.country : formData?.country
        let countryData = formData?.allModel?.country?.filter((v) => v.country_code == firstVehicleCountry)
        dispatch(getVehicleModelList(partnerDetails?.facilities?.[0]?.country_code, countryData?.[0]?.id)).then((res) => {
            setVehicleDetailsList(res)
            if (formData?.vehicleList?.[0]?.state_id && formData?.vehicleList?.[0]?.state_id != '' && formData?.vehicleList?.[0]?.state_id != '0') {
                const selectedState = res?.state?.filter((item) => item?.id == formData?.vehicleList?.[0]?.state_id)
                selectedState?.length > 0 ? setFormData({ ...formData, ['state']: selectedState?.[0]?.state_code }) : setFormData({ ...formData, ['state']: formData?.selFaclity?.geolocations?.state })
            }
            else {
                setFormData({ ...formData, ['state']: formData?.selFaclity?.geolocations?.state, ['city']: formData?.selFaclity?.geolocations?.city })
            }
        })
    }

    useEffect(() => {
        setPage('signup')

        if (isLoggedIn) {
            getVehical()
            const signupFormData = JSON.parse(localStorage.getItem('userData'))
            setLoginData(signupFormData?.user, signupFormData?.user?.state)

            if (signupFormData?.user && Object.values(signupFormData?.user)?.length > 0) {
                // if (signupFormData?.user && Object.values(signupFormData?.user)?.length > 0) {
                const loggedInUserData = signupFormData?.user
                formData['firstname'] = loggedInUserData?.first_name ? loggedInUserData?.first_name : formData?.first_name
                formData['lastname'] = loggedInUserData?.last_name ? loggedInUserData?.last_name : formData?.last_name
                formData['email'] = loggedInUserData?.email ? loggedInUserData?.email : formData?.email
                formData['phone'] = loggedInUserData?.phone_number ? loggedInUserData?.phone_number : formData?.phone
                formData['address1'] = loggedInUserData?.address ? loggedInUserData?.address : formData?.address1
                formData['address2'] = loggedInUserData?.address2 ? loggedInUserData?.address2 : formData?.address2
                formData['city'] = loggedInUserData?.city ? loggedInUserData?.city : formData?.city
                formData['country'] = loggedInUserData?.country ? loggedInUserData?.country : formData?.country
                formData['state'] = loggedInUserData?.state ? loggedInUserData?.state : formData?.state
                formData['zipcode'] = loggedInUserData?.pincode ? loggedInUserData?.pincode : formData?.pincode
                setFormData({ ...formData })
                getStateByCountry(loggedInUserData?.country ? loggedInUserData?.country : formData?.country)
            }
        } else {
            setFormData({ ...formData })
            getVehical()
        }



    }, [EMPTY_ARRAY, isLoggedIn])

    const handleModalOpen = () => {
        setLoginModal(true)
        setCaller('signup')
    }

    // show and hide password 
    const togglePasswordVisiblity = (e, key) => {
        if (key === 'password') {
            setMPasswordShown(mpasswordShown ? false : true)
        }
        if (key === 'cpassword') {
            setCPasswordShown(cpasswordShown ? false : true)
        }
    }

    // console.log('formData signup',formData)
    // console.log('vehicleDetailsList signup',vehicleDetailsList)
    // console.log('loginData signup',loginData)

    return (


        <div >
            <h4 className="text-center my-4 mb-4">Account Information</h4>
            {!isLoggedIn && <div className="bg-white card p-3 mb-4">
                <p className="m-0">
                    <button type='button' className="btn btn-outline-primary" onClick={handleModalOpen} data-bs-target="#loginModal">LOG
                        IN</button> <strong> OR CREATE ACCOUNT BELOW</strong><br /><small
                            className="text-danger">*You must log in or create a new account to
                        proceed.</small>
                </p>
            </div>}

            <div className="mt-2">
                <div className="row g-2">
                    <div className="col-sm-6">
                        <div className="mb-2">
                            <label className="form-label">First Name <span className='text-danger'> *</span></label>
                            <input
                                ref={inputRef}
                                className="form-control "
                                id="firstname" name="firstname" placeholder="First Name"
                                maxLength={20}
                                minLength={1}
                                disabled={(isLoggedIn && loginData?.firstname) ? true : false}
                                value={formData?.firstname ? formData?.firstname : ''}
                                onChange={handleInputFieldsData}
                                required="" type="text" />
                            {requiredTextInput(validator?.current, 'firstname', formData?.firstname, 'First Name', 'required|min:1')}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="mb-2">
                            {/* <span className='text-danger'> *</span> */}
                            <label className="form-label">Last Name</label>
                            <input
                                maxLength={20}
                                disabled={(!loginData?.last_name) ? false : true}
                                minLength={1}
                                className="form-control "
                                name="lastname" value={formData?.lastname ? formData?.lastname : ''} placeholder="Last Name" required="" type="text" onChange={handleInputFieldsData} />
                            {/* <span className="form-text text-danger h-40">{formError == 'signup' && !formData?.lastname ? 'This field is required' : ''}</span> */}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="mb-2">
                            <label className="form-label">Email <span className='text-danger'> *</span></label><input
                                className="form-control "
                                maxLength={100}
                                disabled={(isLoggedIn && loginData?.email) || isPermissionExist(accessPermissions, 'Get Permit By Email') ? true : false}
                                minLength={1}
                                name="email" placeholder="Email" required="" type="email"
                                value={formData?.email ? formData?.email : ''}
                                onChange={isPermissionExist(accessPermissions, 'Get Permit By Email') ? '' : handleInputFieldsData}
                                // onChange={handleInputFieldsData}
                                onKeyPress={(e) => handleKeyPressRestrictLeadingTrailingSpace(e, true)}
                                pattern="^[^@]+@[^@]+.[a-zA-Z]{2,6}" />
                            <span className="form-text text-danger h-40">{formError == 'signup' ? !formData?.email ? 'This field is required' : !validateEmail(formData?.email, formData?.selectedCategory, formData?.selectedPermitType?.[0]) ? (formData?.selectedCategory?.email_domain_validation == 1 || formData?.selectedPermitType?.[0]?.email_domain_validation == 1) ? 'Please use a valid university email id' : 'Please enter a valid email id' : '' : ''}</span>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="mb-2">
                            <label className="form-label">Phone Number {isPermissionExist(accessPermissions, 'Permit Phone Mandatory') && formData?.selFaclity?.facility_configuration?.permit_phone_required == '1' ? <span className='text-danger'> *</span> : ''}</label>
                            <MaskedInput
                                maskGenerator={phoneMaskGenerator}
                                value={formData?.phone ? formData?.phone : ''}
                                type="text"
                                name="phone"
                                id="phone"
                                className="form-control"
                                required={isPermissionExist(accessPermissions, 'Permit Phone Mandatory') && formData?.selFaclity?.facility_configuration?.permit_phone_required == '1' ? true : false}
                                // pattern="[0-9 \\-\(\)\]{14}"
                                maxLength={14}
                                minLength={14}
                                title="Please enter a valid phone number"
                                onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
                                onInput={e => e.target.setCustomValidity('')}
                                placeholder="Phone Number"
                                onChange={handlePhoneChange}
                            />
                            {requiredTextInput(
                                validator?.current,
                                'phone',
                                formData?.phone,
                                'Phone Number',
                                isPermissionExist(accessPermissions, 'Permit Phone Mandatory') && formData?.selFaclity?.facility_configuration?.permit_phone_required == '1'
                                    ? 'required|phone'
                                    : 'phone')}
                        </div>
                    </div>

                </div>
                <div className="row g-2">
                    <div className="col-sm-6">
                        <div className="mb-2">
                            <label className="form-label">Address Line 1 <span className='text-danger'> *</span></label><input
                                className="form-control "
                                name="address1" placeholder="Address Line 1" required=""
                                value={formData?.address1 ? formData?.address1 : ''}
                                onChange={handleInputFieldsData}
                                type="text" />
                            {requiredTextInput(validator?.current, 'address1', formData?.address1, 'Address')}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="mb-2">
                            <label className="form-label">Address Line 2 </label><input
                                className="form-control ng-untouched ng-pristine ng-valid"
                                name="address2" placeholder="Address Line 2 (optional)"
                                value={formData?.address2 ? formData?.address2 : ''}
                                onChange={handleInputFieldsData}
                                type="text" /></div>
                    </div>

                    {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? <div className="col-sm-3 col-xs-6">
                        <div className="mb-2">
                            <label className="form-label">Country <span className='text-danger'> *</span></label>
                            {(formData?.country && vehicleDetailsList?.country) ? <select className='form-select form-control' placeholder="Country" name="country" id='country' onChange={(e) => handleInputFieldsData(e)}>
                                <option value=''>Select an option</option>
                                {(vehicleDetailsList?.country?.length > 0) && vehicleDetailsList?.country?.map((item, itemIndex) => {
                                    if (item?.country_code == 'US' || item?.country_code == 'CA' || item?.country_code == 'GB') {
                                        return <option key={(itemIndex + 1)} selected={item?.country_code == formData?.country || item?.name == formData?.country || item?.country_code == loginData?.country || item?.name == loginData?.country} value={item?.country_code}>{item?.name}</option>
                                    }
                                }
                                )}
                            </select> : <div className="form-select"><Circles
                                height="15"
                                width="15"
                                color="var(--bs-primary)"
                                ariaLabel="circles-loading"
                                visible={true}
                            /></div>}
                            {requiredTextInput(validator?.current, 'country', formData?.country, 'Country')}
                        </div>
                    </div> : ''}
                    <div className="col-sm-3 col-xs-6">
                        <div className="mb-2">
                            <label className="form-label">State <span className='text-danger'> *</span></label>
                            {(vehicleDetailsList?.state) ?
                                <select className='form-select form-control' placeholder="State" name="state" id='state' onChange={(e) => handleInputFieldsData(e)}>
                                    <option value=''>Select an option</option>
                                    {(vehicleDetailsList?.state?.length > 0) && vehicleDetailsList?.state?.map((item, itemIndex) => {
                                        return <option key={(itemIndex + 1)} value={item?.state_code} selected={item?.id == formData?.state || item?.state_code == formData?.state}>{item?.state_code}</option>
                                    })
                                    }
                                </select> : <div className="form-select"><Circles
                                    height="15"
                                    width="15"
                                    color="var(--bs-primary)"
                                    ariaLabel="circles-loading"
                                    visible={true}
                                /></div>}
                            {/* {(vehicleDetailsList?.state) ?
                                <select className='form-select form-control' placeholder="State" name="state" id='state' onChange={(e) => handleInputFieldsData(e)}>
                                    <option value=''>Select an option</option>
                                    {(vehicleDetailsList?.state?.length > 0) && vehicleDetailsList?.state?.map((item, itemIndex) => {
                                        return <option key={(itemIndex + 1)} value={item?.id} selected={item?.id == formData?.state || item?.id == loginData?.state || item?.state_code == formData?.state || item?.state_code == loginData?.state}>{item?.state_code}</option>
                                    })
                                    }
                                </select> : <div className="form-select"><Circles
                                    height="15"
                                    width="15"
                                    color="var(--bs-primary)"
                                    ariaLabel="circles-loading"
                                    visible={true}
                                /></div>} */}
                            {requiredTextInput(validator?.current, 'state', formData?.state, 'State')}
                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-6">
                        <div className="mb-2">
                            <label className="form-label">City <span className='text-danger'> *</span></label>
                            {(vehicleDetailsList?.state) ? <input
                                className="form-control "
                                name="city" value={formData?.city ? formData?.city : ''} placeholder="City" required="" type="text" onChange={handleInputFieldsData} />
                                : <div className="form-select"><Circles
                                    height="15"
                                    width="15"
                                    color="var(--bs-primary)"
                                    ariaLabel="circles-loading"
                                    visible={true}
                                /></div>}
                            {requiredTextInput(validator?.current, 'city', formData?.city, 'City')}
                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-6">
                        <div className="mb-2">
                            <label className="form-label">Zip Code <span className='text-danger'> *</span></label><input
                                className="form-control "
                                maxLength="6" minLength="5" name="zipcode"
                                autoComplete="new-password"
                                value={formData?.zipcode ? formData?.zipcode : ''}
                                placeholder="Zip Code" required="" type="text" onChange={handleInputFieldsData}
                                onPaste={(e) => {
                                    e.preventDefault()
                                    return false
                                }}
                                onKeyPress={(e) => isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? restrictSpecialChar(e) : restrictInputValues(e)}

                            />
                            {requiredTextInput(validator?.current, 'zipcode', formData?.zipcode, 'Zip Code')}
                        </div>
                    </div>
                </div>


                {!isLoggedIn && <div className=" mt-2 ">
                    <p className="fw-bold mt-3 mb-2"  >
                        <span >Create Account Password <i className='text-danger' > * </i>
                            <span className="popoverSection position-relative"  >
                                <div className='small popoverContent position-absolute shadow-sm bg-white p-2 border'>Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-). </div>
                                <i
                                    className="fa fa-question-circle "
                                >
                                </i>
                            </span>

                        </span>
                    </p>
                    <div className="row g-2">
                        <div className="col-sm-6">
                            <div className="mb-2">
                                <div className='position-relative'>
                                    <input
                                        className="form-control"
                                        name="password" placeholder="Create Password" required=""
                                        value={formData?.password}
                                        autoComplete="new-password"
                                        onChange={(e) => setFormData({ ...formData, ['password']: restrictInValidCharPassword(e?.target?.value) })}
                                        type={(!mpasswordShown) ? 'password' : 'text'}
                                        minLength={8}
                                        maxLength={15}
                                        onKeyPress={(e) => handleKeyPressRestrictLeadingTrailingSpace(e, true)}
                                    />
                                    <button type='button' tabIndex="-1" onClick={(e) => togglePasswordVisiblity(e, 'password')} className='btn btn-default position-absolute border-0 right-0 top-0 z-3 p-1'><i className={(!mpasswordShown) ? 'fas fa-eye-slash' : 'fas fa-eye'} ></i></button>
                                </div>
                                <span className="form-text text-danger h-40">{formError == 'signup' ? !formData?.password ? 'This field is required' : !validatePassword(formData?.password) ? 'Please enter a valid password ' : !matchPassword(formData?.password, formData?.cpassword) ? 'Passwords does not match' : '' : ''}</span>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="mb-2">
                                <div className='position-relative'>
                                    <input
                                        className="form-control ng-untouched ng-pristine ng-invalid"
                                        value={formData?.cpassword}
                                        autoComplete="new-password"
                                        name="cpassword" placeholder="Confirm Password" required=""
                                        onChange={(e) => setFormData({ ...formData, ['cpassword']: restrictInValidCharPassword(e?.target?.value) })}
                                        type={(!cpasswordShown) ? 'password' : 'text'}
                                        minLength={8}
                                        maxLength={15}
                                        onKeyPress={(e) => handleKeyPressRestrictLeadingTrailingSpace(e, true)}
                                    />
                                    <button type='button' tabIndex="-1" onClick={(e) => togglePasswordVisiblity(e, 'cpassword')} className='btn btn-default position-absolute border-0 right-0 top-0 z-3 p-1'><i className={(!cpasswordShown) ? 'fas fa-eye-slash ' : 'fas fa-eye '} ></i></button>

                                </div><span className="form-text text-danger">{formError == 'signup' ? !formData?.cpassword ? 'This field is required' : !validatePassword(formData?.cpassword) ? 'Please enter a valid password ' : !matchPassword(formData?.password, formData?.cpassword) ? 'Passwords does not match' : '' : ''}</span>
                            </div>
                        </div>
                    </div>

                </div>
                }
            </div>
            <Login isLoginModal={isLoginModal} setLoginModal={setLoginModal} caller={caller} />
        </div>
    )
}

SignUp.propTypes = {
    dispatch: PropTypes.func,
    data: PropTypes.object,
    events: PropTypes.object,
    loader: PropTypes.bool,
    getCard: PropTypes.func,
    passData: EMPTY_ARRAY,
    setPage: PropTypes.func,
    isLoggedIn: PropTypes.bool,
    formData: PropTypes.object,
    setFormData: PropTypes.func,
    formError: PropTypes.string,
    partnerDetails: PropTypes.object,
    setInvalidCredentialsError: PropTypes.func,
    validator: PropTypes.object,
}

SignUp.defaulProps = {
    dispatch: noop,
    data: EMPTY_OBJECT,
    events: EMPTY_OBJECT,
    loader: PropTypes.bool,
    getCard: PropTypes.func,
    passData: EMPTY_ARRAY,
    setPage: noop,
    isLoggedIn: false,
    formData: EMPTY_OBJECT,
    setFormData: noop,
    formError: undefined,
    partnerDetails: EMPTY_OBJECT,
    setInvalidCredentialsError: noop,
}


function mapStateToProps({ paymentReducer }) {
    return {
        data: paymentReducer,
    }

}
export default connect(mapStateToProps)(SignUp)
